import React, { useState, useEffect } from "react";
import { MdCancel, MdOutlineZoomOutMap } from "react-icons/md";
import Hexapi from "../usefulcomps/HexAPI/Hexapi";
import { Table, Modal, Button } from "react-bootstrap";
import QuotationLog from "./QuotationLog";
import PurchaseOrderLog from "./PurchaseOrderLog";
import MoneyReceiptLog from "./MoneyReceiptLog";
import UpdateFollowup from "./UpdateFollowup";
import EditEnquiry from "./EditEnquiry";
import DeleteEnquiry from "./DeleteEnquiry";

function ActionModal(props) {
  const [FollowUpRowdata, SetFollowUpRowdata] = useState([]);
  const [FollowupHeaders, setFollowupHeaders] = useState([]);
  const [modalLoading, setModalLoading] = useState(true);
  const [activeChildModal, setActiveChildModal] = useState(null);

  useEffect(() => {
    fetchRowDetails(props.enquiryID);
  }, [props.enquiryID]);

  const fetchRowDetails = async (enquiryID) => {
    setModalLoading(true);
    console.log(activeChildModal);
    let obj = {
      query: `[dbo].[CRM_Proc_ActionModal_GetData]@EnquiryID='{0}', @agentID='{1}'`,
      queryArr: [`${enquiryID}`, `${props.AgentID}`],
    };
    try {
      const resp = await Hexapi(obj);
      console.log("Row details:", resp);
      SetFollowUpRowdata(resp.followupdetails);
      if (resp.followupdetails.length > 0) {
        setFollowupHeaders(Object.keys(resp.followupdetails[0]));
      }
      setModalLoading(false);
    } catch (err) {
      console.error("Error fetching row details:", err);
    } finally {
      setModalLoading(false);
    }
  };

  return (
    // FIX: Always keep show={true} (driven by props.show) so the modal stays
    // mounted in the DOM. When a child modal is open we simply hide it visually
    // via style so React never unmounts/remounts the child components — which
    // was the root cause of the auto-close bug and corrupted activeChildModal state.
    <Modal
      show={props.show}
      onHide={() => {
        if (activeChildModal === null) {
          props.onHide();
        }
      }}
      dialogClassName="custom-modal"
      backdrop="static"
      centered
      // Hide ActionModal visually while a child modal is active.
      // This prevents Bootstrap from closing it while keeping children alive.
      style={{
        opacity: activeChildModal !== null ? 0 : 1,
        pointerEvents: activeChildModal !== null ? "none" : "auto",
        transition: "opacity 0.15s ease",
      }}
    >
      <Modal.Header style={{ backgroundColor: "#f5f9ff" }}>
        <div
          className=" d-flex align-items-center"
          style={{ justifyContent: "space-between", width: "100%" }}
        >
          <Modal.Title>Action</Modal.Title>
          <QuotationLog
            AgentID={props.AgentID}
            enquiryID={props.enquiryID}
            customerName={props.customerName}
            isOpen={activeChildModal === "quotation"}
            onOpen={() => setActiveChildModal("quotation")}
            onClose={() => setActiveChildModal(null)}
            ReloadActionModal={(enquiryID) => fetchRowDetails(enquiryID)}
          />
          <PurchaseOrderLog
            AgentID={props.AgentID}
            enquiryID={props.enquiryID}
            customerName={props.customerName}
            isOpen={activeChildModal === "purchaseorder"}
            onOpen={() => setActiveChildModal("purchaseorder")}
            onClose={() => setActiveChildModal(null)}
            ReloadActionModal={(enquiryID) => fetchRowDetails(enquiryID)}
          />
          <MoneyReceiptLog
            AgentID={props.AgentID}
            enquiryID={props.enquiryID}
            customerName={props.customerName}
            isOpen={activeChildModal === "moneyreceipt"}
            onOpen={() => setActiveChildModal("moneyreceipt")}
            onClose={() => setActiveChildModal(null)}
            ReloadActionModal={(enquiryID) => fetchRowDetails(enquiryID)}
          />
          <UpdateFollowup
            AgentID={props.AgentID}
            enquiryID={props.enquiryID}
            customerName={props.customerName}
            isOpen={activeChildModal === "followup"}
            onOpen={() => setActiveChildModal("followup")}
            onClose={() => setActiveChildModal(null)}
            ReloadActionModal={(enquiryID) => fetchRowDetails(enquiryID)}
          />
          <EditEnquiry
            enquiryID={props.enquiryID}
            customerName={props.customerName}
            isOpen={activeChildModal === "edit"}
            onOpen={() => setActiveChildModal("edit")}
            onClose={() => setActiveChildModal(null)}
            ReloadActionModal={(enquiryID) => fetchRowDetails(enquiryID)}
            leadTypeID={props.leadTypeID}
          />
          <DeleteEnquiry
            enquiryID={props.enquiryID}
            customerName={props.customerName}
            ReloadActionModal={(enquiryID) => fetchRowDetails(enquiryID)}
          />
          <MdCancel
            style={{ cursor: "pointer", fontSize: "25px" }}
            title="Cancel"
            onClick={() => props.onHide()}
          />
        </div>
      </Modal.Header>

      <Modal.Body style={{ maxHeight: "85vh", overflowY: "auto" }}>
        <div className="container-fluid">
          {!modalLoading ? (
            FollowUpRowdata.length > 0 ? (
              <>
                <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                  <Table
                    striped
                    className="custom-table w-100"
                    size="sm"
                    style={{ borderCollapse: "collapse" }}
                  >
                    <thead>
                      <tr
                        style={{
                          background: "#000",
                          color: "white",
                          position: "sticky",
                          top: "0px",
                        }}
                      >
                        {FollowupHeaders.map((s, index) => (
                          <th
                            key={index}
                            style={{
                              background: "#000",
                              color: "white",
                              position: "sticky",
                              top: 0,
                              zIndex: 2,
                              whiteSpace: "nowrap",
                            }}
                          >
                            {s.toUpperCase()}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody style={{ whiteSpace: "nowrap", cursor: "pointer" }}>
                      {FollowUpRowdata.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                          {FollowupHeaders.map((col, colIndex) => (
                            <td key={colIndex}>{String(row[col])}</td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </>
            ) : (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ minHeight: "200px" }}
              >
                <span className="">No Records!</span>
              </div>
            )
          ) : (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: "200px" }}
            >
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ActionModal;
